import React from 'react';
import { Modal } from 'antd';
function Terms({ isOpen, onClose }) {
  return (
    <Modal
      title="Terms and Conditions"
      open={isOpen}
      onCancel={onClose}
      footer={null} // Removes default buttons
      centered
      width={800}
    >
      <div className="w-full flex my-[50px] justify-center">
        <div className="w-[1200px] h-[700px] p-16 overflow-auto shadow-xl">
          <h1 className="text-[#003478]  font-extrabold text-2xl text-center ">
            {' '}
            Terms & Condition
          </h1>
          <hr className="my-8 h-1 " />

          <p>
            EFFICIENT Insurance Brokers Private Limited operates the website
            www.insureefficient.com to provide consumers choice and an easy way
            to buy Insurance products from multiple Insurance companies.
            EFFICIENT is not an insurance company. EFFICIENT is a licensed
            Insurance Broking Company holding a Broking licence from the Indian
            Insurance Regulator – Insurance Regulatory and Development
            authority.
          </p>

          <p className="font-extrabold text-lg  my-4  ">
            IRDA Direct Broker Code: DB 339/06
          </p>

          <p>
            Our participating insurance providers supply some of the information
            available on the Website and therefore there may be inaccuracies in
            the Website Information over which EFFICIENT has limited control.{' '}
            <br />
            EFFICIENT does not warrant or guarantee the Timeliness, accuracy or
            completeness of the Website Information; or Quality of the results
            obtained from the use of the Website.
            <br />
            To the maximum extent permitted by law, EFFICIENT has no liability
            in relation to or arising out of the Website Information and Website
            recommendations. You are responsible for the final choice of your
            product and you should take time to read through all information
            supplied before proceeding. If you are in any doubt regarding a
            product or its terms you should seek further advice from EFFICIENT
            or the relevant participating provider before choosing your product.
            <br />
            <br />
            EFFICIENT may pass on your personal information to the relevant
            participating provider if you apply to purchase a product through
            www.insureefficient.com, however, EFFICIENT does not guarantee when
            or if you will actually acquire the product that you have chosen.
            EFFICIENT does not accept any liability arising out of circumstances
            where there is delay in you acquiring the product you have chosen.
            <br /> <br />
            Please note that EFFICIENT is only collecting or assisting in
            collecting the premium deposit on behalf of the insurer you have
            chosen to buy the policy. The acceptance of the deposit as premium
            and final issuance of the policy is subject to the underwriting
            norms and discretion of the Insurer whose policy you have chosen to
            buy on which EFFICIENT has no control. EFFICIENT will ensure that
            the amount is refunded by the insurer in case there is no ultimate
            issuance of policy.
            <br />
            <br />
            By visiting our website and accessing the information, resources,
            services, products, and tools we provide, you understand and agree
            to accept and adhere to the following terms and conditions as stated
            in this policy (hereafter referred to as ‘User Agreement’), along
            with the terms and conditions as stated in our Privacy Policy
            (please refer to the Privacy Policy section below for more
            information).
            <br /> <br />
            We reserve the right to change this User Agreement from time to time
            without notice. You acknowledge and agree that it is your
            responsibility to review this User Agreement periodically to
            familiarize yourself with any modifications. Your continued use of
            this site after such modifications will constitute acknowledgment
            and agreement of the modified terms and conditions.
            <br />
            <br />
          </p>
          <br />
          <br />

          <p className="font-extrabold text-lg  my-4 ">
            Responsible Use and Conduct
          </p>

          <p>
            By visiting our website and accessing the information, resources,
            services, products, and tools we provide for you, either directly or
            indirectly (hereafter referred to as ‘Resources’), you agree to use
            these Resources only for the purposes intended as permitted by (a)
            the terms of this User Agreement, and (b) applicable laws,
            regulations and generally accepted online practices or guidelines.{' '}
            <br /> <br />
            Wherein, you understand that: In order to access our Resources, you
            may be required to provide certain information about yourself (such
            as identification, contact details, etc.) as part of the
            registration process, or as part of your ability to use the
            Resources. You agree that any information you provide will always be
            accurate, correct, and up to date.
            <br /> <br />
            You are responsible for maintaining the confidentiality of any login
            information associated with any account you use to access our
            Resources. Accordingly, you are responsible for all activities that
            occur under your account/s.
            <br /> <br />
            Accessing (or attempting to access) any of our Resources by any
            means other than through the means we provide, is strictly
            prohibited. You specifically agree not to access (or attempt to
            access) any of our Resources through any automated, unethical or
            unconventional means.
            <br /> <br />
            Engaging in any activity that disrupts or interferes with our
            Resources, including the servers and/or networks to which our
            Resources are located or connected, is strictly prohibited.
            Attempting to copy, duplicate, reproduce, sell, trade, or resell our
            Resources is strictly prohibited.
            <br /> <br />
            You are solely responsible any consequences, losses, or damages that
            we may directly or indirectly incur or suffer due to any
            unauthorized activities conducted by you, as explained above, and
            may incur criminal or civil liability. <br /> <br />
            We may provide various open communication tools on our website, such
            as blog comments, blog posts, public chat, forums, message boards,
            newsgroups, product ratings and reviews, various social media
            services, etc. You understand that generally we do not pre-screen or
            monitor the content posted by users of these various communication
            tools, which means that if you choose to use these tools to submit
            any type of content to our website, then it is your personal
            responsibility to use these tools in a responsible and ethical
            manner. By posting information or otherwise using any open
            communication tools as mentioned, you agree that you will not
            upload, post, share, or otherwise distribute any content that:{' '}
            <br /> <br />
            Is illegal, threatening, defamatory, abusive, harassing, degrading,
            intimidating, fraudulent, deceptive, invasive, racist, or contains
            any type of suggestive, inappropriate, or explicit language;
            Infringes on any trademark, patent, trade secret, copyright, or
            other proprietary right of any party; Contains any type of
            unauthorized or unsolicited advertising; Impersonates any person or
            entity, including any www.insureefficient.com employees or
            representatives.
            <br /> <br />
            We have the right at our sole discretion to remove any content that,
            we feel in our judgment does not comply with this User Agreement,
            along with any content that we feel is otherwise offensive, harmful,
            objectionable, inaccurate, or violates any 3rd party copyrights or
            trademarks. We are not responsible for any delay or failure in
            removing such content. If you post content that we choose to remove,
            you hereby consent to such removal, and consent to waive any claim
            against us.
            <br /> <br />
            We do not assume any liability for any content posted by you or any
            other 3rd party users of our website. However, any content posted by
            you using any open communication tools on our website, provided that
            it doesn’t violate or infringe on any 3rd party copyrights or
            trademarks, becomes the property of EFFICIENT Insurance Brokers Pvt.
            Ltd., and as such, gives us a perpetual, irrevocable, worldwide,
            royalty-free, exclusive license to reproduce, modify, adapt,
            translate, publish, publicly display and/or distribute as we see
            fit. This only refers and applies to content posted via open
            communication tools as described, and does not refer to information
            that is provided as part of the registration process, necessary in
            order to use our Resources. All information provided as part of our
            registration process is covered by our privacy policy.
            <br /> <br />
            You agree to indemnify and hold harmless EFFICIENT Insurance Brokers
            Pvt. Ltd. and its parent company and affiliates, and their
            directors, officers, managers, employees, donors, agents, and
            licensors, from and against all losses, expenses, damages and costs,
            including reasonable attorney&apos;s fees, resulting from any
            violation of this User Agreement or the failure to fulfil any
            obligations relating to your account incurred by you or any other
            person using your account. We reserve the right to take over the
            exclusive defence of any claim for which we are entitled to
            indemnification under this User Agreement. In such event, you shall
            provide us with such cooperation as is reasonably requested by us.
          </p>

          <p className="font-extrabold text-lg  my-4">Privacy</p>
          <p>
            Your privacy is very important to us, which is why we’ve created a
            separate Privacy Policy in order to explain in detail how we
            collect, manage, process, secure, and store your private
            information. Our privacy policy is included under the scope of this
            User Agreement. To read our privacy policy in its entirety, click
            here.
          </p>

          <p className="font-extrabold text-lg  my-4">
            Limitation of Warranties
          </p>
          <p>
            By using our website, you understand and agree that all Resources we
            provide are “as is” and “as available”. This means that we do not
            represent or warrant to you that: The use of our Resources will meet
            your needs or requirements. The use of our Resources will be
            uninterrupted, timely, secure or free from errors. The information
            obtained by using our Resources will be accurate or reliable, and
            Any defects in the operation or functionality of any Resources we
            provide will be repaired or corrected. Furthermore, you understand
            and agree that: <br />
            <br />
            Any content downloaded or otherwise obtained through the use of our
            Resources is done at your own discretion and risk, and that you are
            solely responsible for any damage to your computer or other devices
            for any loss of data that may result from the download of such
            content.
            <br /> <br />
            No information or advice, whether expressed, implied, oral or
            written, obtained by you from EFFICIENT Insurance Brokers Pvt. Ltd.
            or through any Resources we provide shall create any warranty,
            guarantee, or conditions of any kind, except for those expressly
            outlined in this User Agreement.
          </p>
          <p className="font-extrabold text-lg  my-4">
            Limitation of Liability
          </p>
          <p>
            In conjunction with the Limitation of Warranties as explained above,
            you expressly understand and agree that any claim against us shall
            be limited to the amount you paid, if any, for use of products
            and/or services. EFFICIENT Insurance Brokers Pvt. Ltd. will not be
            liable for any direct, indirect, incidental, consequential or
            exemplary loss or damages which may be incurred by you as a result
            of using our Resources, or as a result of any changes, data loss or
            corruption, cancellation, loss of access, or downtime to the full
            extent that applicable limitation of liability laws apply.
          </p>

          <p className="font-extrabold text-lg  my-4">Copyrights/Trademarks</p>
          <p>
            All content and materials available on www.insureefficient.com,
            including but not limited to text, graphics, website name, code,
            images and logos are the intellectual property of EFFICIENT
            Insurance Brokers Pvt. Ltd., and are protected by applicable
            copyright and trademark law. Any inappropriate use, including but
            not limited to the reproduction, distribution, display or
            transmission of any content on this site is strictly prohibited,
            unless specifically authorized by EFFICIENT Insurance Brokers Pvt.
            Ltd.
          </p>

          <p className="font-extrabold text-lg  my-4">Termination of Use</p>
          <p>
            You agree that we may, at our sole discretion, suspend or terminate
            your access to all or part of our website and Resources with or
            without notice and for any reason, including, without limitation,
            breach of this User Agreement. Any suspected illegal, fraudulent or
            abusive activity may be grounds for terminating your relationship
            and may be referred to appropriate law enforcement authorities. Upon
            suspension or termination, your right to use the Resources we
            provide will immediately cease, and we reserve the right to remove
            or delete any information that you may have on file with us,
            including any account or login information.
          </p>

          <p className="font-extrabold text-lg  my-4">Guarantee</p>
          <p>
            UNLESS OTHERWISE EXPRESSED, EFFICIENT Insurance Brokers Pvt. Ltd.
            EXPRESSLY DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND,
            WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE
            IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NON-INFRINGEMENT.
          </p>
          <p className="font-extrabold text-lg  my-4">
            Nominee Assistance Program
          </p>
          <p>
            EFFICIENT Insurance Brokers Private Limited has merely partnered
            with various third party experts in order to facilitate extended
            services to the users purchasing Term Insurance. The services
            provided by the third party(s) are provided by them in their
            capacity as an independent service provider(s). EFFICIENT do not
            provide the services in any capacity whatsoever. EFFICIENT do not
            endorse the services of the listed partners. EFFICIENT shall not be
            liable for any payment obligation in relation to the services
            provided under the Nominee Assistance program. <br />
            <br />
            EFFICIENT shall not be liable for any act(s)/omission(s) of the
            partners and/or any defect/deficiency in provision of the listed
            services including their refusal to provide the services. Any third
            party facility/offer(s)/service(s)/product(s) (“offer”) shall be
            subject to the terms and conditions of such third party which shall
            be applicable to the user. EFFICIENT do not endorse, make no
            representation and shall have no liability or obligation whatsoever
            in relation to such third party offer.
            <br />
            <br />
            All such third party offer shall be availed by user at their own
            risk and responsibility. EFFICIENT shall not be liable for any
            payment obligation in relation to such third party offer, which
            shall be users responsibility.
            <br /> <br />
            EFFICIENT is only an insurance broker and can assist with any
            insurance claims only to the extent of liasioning with the insurance
            company. Any insurance claim shall be processed by the insurance
            company subject to their terms and conditions and the insurance
            policy.
            <br /> <br />
            EFFICIENT reserves the sole right to modify, amend, change, refuse
            or revoke their respective services, any offers including third
            party offer herein at any time without assigning any reason and
            without any liability and notice.
            <br /> <br />
            These terms and conditions for Nominee Assistance Program are in
            addition to all other terms and conditions provided hereunder
            including the FAQs and all these terms and conditions and FAQs are
            legally binding on the user. EFFICIENT reserves the sole right to
            modify, amend, change or revoke these terms and conditions including
            the FAQs without any notice at any time and all such terms and
            conditions and FAQs as amended from time to time shall be legally
            binding on the user.
            <br /> <br />
            Any disputes arising pursuant to these terms and conditions are
            subject to the exclusive jurisdiction of courts in Mumbai.
            <br /> <br />
            Your acceptance of these terms
            <br /> <br />
            By using this Site, you signify your acceptance of this policy. If
            you do not agree to this policy, please do not use our Site. Your
            continued use of the Site following the posting of changes to this
            policy will be deemed your acceptance of those changes.
            <br /> <br />
            Contact Information <br />
            <br />
            If you have any questions or comments about these our Terms of
            Service as outlined above, you can contact us at:
            <br />
            <br />
            EFFICIENT Insurance Brokers Pvt. Ltd.
            <br />
            <br />
            Office No. 28, Second Floor, Navkar Paradise, L T Road, Babhai Naka,
            Borivali West, Mumbai - 400092
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Terms;
